import React from 'react';
import { t } from '@web-solutions/module-localization';

import { useNav } from '../../../hooks/nav';
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../../assets/images/arrowLeft.svg';

import tashaImg from '../../../assets/images/tashaWithoutFace.png';
import isabellaImg from '../../../assets/images/IsabellaWithotFace.png';
import MichaelImg from '../../../assets/images/michael.webp';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import Button from 'src/onboarding/components/ui/button/Button';
import Analytics from '@web-solutions/module-analytics';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

const Page = () => {
  const { onPrev, onNext, currentIndex } = useNav();

  const customers = [
    {
      img: tashaImg,
      name: t('onboarding.glpReviews.customers.1.name'),
      descriptions: t('onboarding.glpReviews.customers.1.description', {
        interpolation: { escapeValue: false },
      }),
    },
    {
      img: MichaelImg,
      name: t('onboarding.glpReviews.customers.2.name'),
      descriptions: t('onboarding.glpReviews.customers.2.description', {
        interpolation: { escapeValue: false },
      }),
    },
    {
      img: isabellaImg,
      name: t('onboarding.glpReviews.customers.3.name'),
      descriptions: t('onboarding.glpReviews.customers.3.description', {
        interpolation: { escapeValue: false },
      }),
    },
  ];

  const isFirst = currentIndex === 0;

  return (
    <div className={`page ${styles.top}`}>
      {!isFirst && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <div className={styles.reviews}>
          {customers.map(({ img, name, descriptions }) => (
            <div className={styles.review} key={name}>
              <div className={styles.reviewImgContainer}>
                <img className={styles.reviewImg} src={img} alt='customer' />

                <div className={styles.stateBefore}>
                  <Caption size='l'>{t('onboarding.glpReviews.before')}</Caption>
                </div>
                <div className={styles.stateAfter}>
                  <Caption size='l'>{t('onboarding.glpReviews.after')}</Caption>
                </div>
              </div>

              <div className={styles.reviewDescription}>
                <Caption size='l'>{name}</Caption>
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: descriptions }}
                />
              </div>
            </div>
          ))}
        </div>
        <Title tag='h2'>{t('onboarding.biggerCommunityTransition.title')}</Title>
        <Text semibold className={styles.description}>
          {t('onboarding.biggerCommunityTransition.text')}
        </Text>
        <div className='overlay'></div>
      </div>
      <div className={'next-wrapper'}>
        <Button
          title={t('onboarding.biggerCommunityTransition.continue')}
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'bigger-community-transition',
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
};

export default Page;
